import * as Yup from 'yup';

const notificationSchema = Yup.object().shape({
  minOrderAmount: Yup.number()
    .positive('Minimum Order Amount must be positive')
    .min(0, 'Minimum Order Amount cannot be less than 0')
    .label('Minimum Order Amount'),
  maxOrderAmount: Yup.number()
    .positive('Maximum Order Amount must be positive')
    .min(0, 'Maximum Order Amount cannot be less than 0')
    .when('minOrderAmount', (minOrderAmount, schema) =>
      minOrderAmount ? schema.required('Maximum Order Amount is required when Minimum Order Amount is set') : schema
    )
    .label('Maximum Order Amount'),
  minOrderCount: Yup.number()
    .positive('Minimum Order Count must be positive')
    .min(0, 'Minimum Order Count cannot be less than 0')
    .label('Minimum Order Count'),
  maxOrderCount: Yup.number()
    .positive('Maximum Order Count must be positive')
    .min(0, 'Maximum Order Count cannot be less than 0')
    .when('minOrderCount', (minOrderCount, schema) =>
      minOrderCount ? schema.required('Maximum Order Count is required when Minimum Order Count is set') : schema
    )
    .label('Maximum Order Count'),
});

export default notificationSchema;